export const RESUME_DATA = "RESUME_DATA";
export const LOG_OUT = "RESUME_DATA";
